export const UPDATE_ENGAGEMENT_ATTACHMENTS = 'UPDATE_ENGAGEMENT_ATTACHMENTS';
export const OPEN_REMOVE_ATTACHMENT_MODAL = 'OPEN_REMOVE_ATTACHMENT_MODAL';
export const UPDATE_NOTE_WITH_EDITS = 'UPDATE_NOTE_WITH_EDITS';